export default __webpack_public_path__ + "static/gdi-background-b04c8b98060fe6be32d0a5dc54f08a5d.jpg";